import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Icon.css';

const cx = classnames.bind(styles);

const SPRITE_PATHNAME = '/images/sprite.svg?v=41';

function Icon({ name, style, onClick, className, ...props }) {
    const iconClasses = cx({
        icon: true,
        [className]: Boolean(className),
        clicked: onClick
    });

    const handleClick = e => {
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <svg
            className={iconClasses}
            onClick={handleClick}
            style={style}
            aria-hidden={!onClick}
            {...props}
        >
            <use href={`${SPRITE_PATHNAME}#${name}`} />
        </svg>
    );
}

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string
};

Icon.defaultProps = {
    onClick: null,
    style: {},
    className: ''
};

export {
    Icon
};
